<template>
    <span :class="ringOffset" class="relative flex items-center bg-white dark:bg-slate-700 rounded-full transition duration-100 ease-in-out ring-1 ring-white dark:ring-slate-700 ring-offset-white dark:ring-offset-slate-700">
        <img v-if="!hasIcon && imgSrc" :alt="alt" :src="imgSrc" class="w-full h-full rounded-full object-cover" />
        <span v-if="!hasIcon && !imgSrc" class="inline-block bg-gray-100 rounded-full object-cover overflow-hidden">
            <svg class="w-full h-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
        </span>
        <span :class="[clientWidth < 48 ? 'px-1.5' : 'px-2']" class="profile-icon w-full h-full bg-indigo-700 rounded-full overflow-hidden" v-if="hasIcon" v-html="user.profileIcon"></span>
        <span aria-hidden="true" class="absolute z-10 inset-0 rounded-full shadow-inner"></span>
        <span v-show="userOnlineStatus || isBot" class="absolute z-10 bottom-0 right-0 block w-1/5 h-1/5 bg-green-400 hover:bg-green-500 rounded-full transition duration-150 ease-in-out ring-2 ring-green-400" title="Online"></span>
    </span>
</template>

<script>
export default {
    name: "Avatar",

    mounted() {
        this.clientWidth = this.$el.clientWidth
    },

    props: {
        user: {
            default: null,
            type: Object,
        },
        src: {
            default: null,
            type: String,
        },
        alt: {
            default: "",
            type: String,
        },
        ringOffset: {
            default: "ring-offset-2",
            type: String,
        },
        status: {
            default: null,
            type: Boolean,
        },
    },

    computed: {
        imgSrc() {
            if (this.user) return this.user.profile_photo_url
            return this.src
        },
        userOnlineStatus() {
            if (!this.user) return false
            return this.user.online
        },
        hasIcon() {
            if (!this.user) return false
            return !!this.user.profileIcon
        },
        isBot() {
            if (!this.user) return false
            return this.user.username === "challenge-bot"
        },
    },
    data() {
        return {
            clientWidth: 48,
        }
    },
}
</script>
